<template>
  <div class="counters-section">
      <div class="col-sm-6 col-xs-6 col-xxs-12">
          <div class="achivement-box">
              <i class="fa fa-code"></i>
              <div class="count-container">
                <span class="count">2.7</span><span class="million">M</span>
              </div>
              <h4>سطر برمجي</h4>
          </div>
      </div>
      <div class="col-sm-6 col-xs-6 col-xxs-12">
          <div class="achivement-box">
              <i class="fa fa-cubes"></i>
              <div class="count-container">
                <span class="count">78</span>
              </div>
              <h4>مشروع مكتمل</h4>
          </div>
      </div>
     
  </div>
</template>
<script>
import 'waypoints/lib/jquery.waypoints.min.js'
import 'jquery.counterup/jquery.counterup.min.js'
export default {
    name:'Counter',
    mounted:function(){
        $(document).ready(function(){
            init_counterup();
        });
        // CounterUp
	function init_counterup() {
        if ($("span.count").length > 0) {
            $('span.count').counterUp({
                delay: 10, // the delay time in ms
                time: 1000 // the speed time in ms
            });
        }
    }
       
    },
}
</script>
<style lang="scss">
    .counters-section{
        overflow: auto;
        display:flex;
        width:100%;
        height:100%;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        .achivement-box{
            text-align: center;
            margin:21px 0px;
            padding:21px 0px 20px 0px;
            i{
                font-size: 50px;
                font-weight: 400;
                color: #fff;
            }
            span.count, span.million {
                font-size: 40px;
                color: rgba(#fff,0.7);
                font-family: 'Changa';
                font-weight: 600;
            }
            h4{
                font-size:24px;
                text-transform: uppercase;
                color:#fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/counters.vue